// extracted by mini-css-extract-plugin
export default {"icon--github":"icon--github-VaLQq","icon--spin":"icon--spin-uJ8_8","rotate":"rotate-PWvB6"};